<template>
    <div>
        <v-server-table :url="url ? url : route('trajectories.table')" :columns="columns" :options="options" class="trigger" ref="table">
            <template slot="name" slot-scope="props">
                <router-link :to="{ name: 'admin.trajectory_projects.trajectories.view', params: { projectId: props.row.trajectory_project_id, id: props.row.id }}">{{ props.row.name }}</router-link>
            </template>
            <template slot="amount_of_candidates" slot-scope="props">
                <a href="#" @click.prevent="loadCandidatesModal(props.row)" v-if="props.row.enrolment_count">{{ props.row.enrolment_count }}</a>
                <span v-if="!props.row.enrolment_count">{{ props.row.enrolment_count }}</span>
            </template>
            <template slot="amount_of_active_candidates" slot-scope="props">
                <a href="#" @click.prevent="loadCandidatesModal(props.row, 'active')" v-if="props.row.active_enrolment_count">{{ props.row.active_enrolment_count }}</a>
                <span v-if="!props.row.active_enrolment_count">{{ props.row.active_enrolment_count }}</span>
            </template>
            <template slot="amount_of_completed_candidates" slot-scope="props">
                <a href="#" @click.prevent="loadCandidatesModal(props.row, 'completed')" v-if="props.row.completed_enrolment_count">{{ props.row.completed_enrolment_count }}</a>
                <span v-if="!props.row.completed_enrolment_count">{{ props.row.completed_enrolment_count }}</span>
            </template>
            <template slot="amount_of_successful_completions" slot-scope="props">
                <a href="#" @click.prevent="loadCandidatesModal(props.row, 'completed_successful')" v-if="props.row.completed_successfully_enrolment_count">{{ props.row.completed_successfully_enrolment_count }}</a>
                <span v-if="!props.row.completed_successfully_enrolment_count">{{ props.row.completed_successfully_enrolment_count }}</span>
            </template>
            <template slot="amount_of_unsuccessful_completions" slot-scope="props">
                <a href="#" @click.prevent="loadCandidatesModal(props.row, 'completed_unsuccessful')" v-if="props.row.completed_unsuccessfully_enrolment_count">{{ props.row.completed_unsuccessfully_enrolment_count }}</a>
                <span v-if="!props.row.completed_unsuccessfully_enrolment_count">{{ props.row.completed_unsuccessfully_enrolment_count }}</span>
            </template>
            <template slot="amount_of_completions_at_the_expense_of_the_client" slot-scope="props">
                <a href="#" @click.prevent="loadCandidatesModal(props.row, 'completed_at_the_expense_of_the_client')" v-if="props.row.completed_at_the_expense_of_the_client_enrolment_count">{{ props.row.completed_at_the_expense_of_the_client_enrolment_count }}</a>
                <span v-if="!props.row.completed_at_the_expense_of_the_client_enrolment_count">{{ props.row.completed_at_the_expense_of_the_client_enrolment_count }}</span>
            </template>
            <template slot="amount_of_canceled_candidates" slot-scope="props">
                <a href="#" @click.prevent="loadCandidatesModal(props.row, 'canceled')" v-if="props.row.canceled_enrolment_count">{{ props.row.canceled_enrolment_count }}</a>
                <span v-if="!props.row.canceled_enrolment_count">{{ props.row.canceled_enrolment_count }}</span>
            </template>
            <template slot="active" slot-scope="props">
                <b-badge pill variant="primary">{{ uLang('app.' + (props.row.active ? 'yes' : 'no')) }}</b-badge>
            </template>
        </v-server-table>
        <relation-trajectory-enrolments-modal ref="modal"/>
    </div>
</template>

<script>
    import Actions from './actions'
    import { TableMixin } from '~/mixins'
    import RelationTrajectoryEnrolmentsModal from '~/components/modals/relation-trajectory-enrolments'

    export default {
        name: 'index',
        mixins: [ TableMixin ],
        props: {
            url: {
                type: String,
                required: false,
                default: null,
            },
        },

        components: {
            'relation-trajectory-enrolments-modal': RelationTrajectoryEnrolmentsModal,
        },

        data () {
            return {
                columns: [
                    'name',
                    'amount_of_candidates',
                    'amount_of_active_candidates',
                    'amount_of_completed_candidates',
                    'amount_of_successful_completions',
                    'amount_of_unsuccessful_completions',
                    'amount_of_completions_at_the_expense_of_the_client',
                    'amount_of_canceled_candidates',
                    'active',
                    'actions',
                ],
                filterable: [
                    'name',
                    // 'amount_of_candidates',
                    // 'amount_of_active_candidates',
                    // 'amount_of_completed_candidates',
                    // 'amount_of_successful_completions',
                    // 'amount_of_unsuccessful_completions',
                    // 'amount_of_completions_at_the_expense_of_the_client',
                    // 'amount_of_canceled_candidates',
                    // 'active',
                ],
                templates: {
                    actions: Actions,
                },
                options: {
                    headings: {
                        name: this.uLang('app.name'),
                        amount_of_candidates: this.uLang('app.amount_of_candidates'),
                        amount_of_active_candidates: this.uLang('app.amount_of_active_candidates'),
                        amount_of_completed_candidates: this.uLang('app.amount_of_completed_candidates'),
                        amount_of_successful_completions: this.uLang('app.amount_of_successful_completions'),
                        amount_of_unsuccessful_completions: this.uLang('app.amount_of_unsuccessful_completions'),
                        amount_of_completions_at_the_expense_of_the_client: this.uLang('app.amount_of_completions_at_the_expense_of_the_client'),
                        amount_of_canceled_candidates: this.uLang('app.amount_of_canceled_candidates'),
                        active: this.uLang('app.active'),
                        actions: this.uLang('app.actions'),
                    },
                },
            }
        },

        methods: {
            loadCandidatesModal(trajectory, status) {
                this.$store.dispatch('retrieveEnrolments', {
                    trajectory_project_id: trajectory.trajectory_project_id,
                    trajectory_id: trajectory.id,
                    status: status
                });

                this.$refs.modal.$refs.modal.show();
            },
        },
    }
</script>

<style lang="css" scoped>
</style>